import { Credibility } from '@chegg-wt/core/types/core'

const credibilityHeader = "Consider your source's credibility. Ask these questions:"

const considerCredibility: Credibility = {
  header: credibilityHeader,
  body: [
    {
      header: 'Contributor/Author',
      body: [
        'Has the author written several articles on the topic, and do they have the credentials to be an expert in their field?',
        'Can you contact them? Do they have social media profiles?',
        'Have other credible individuals referenced this source or author?',
        'Book: What have reviews said about it?',
      ],
    },
    {
      header: 'Publisher',
      body: [
        'What do you know about the publisher/sponsor? Are they well-respected?',
        'Do they take responsibility for the content? Are they selective about what they publish?',
        'Take a look at their other content. Do these other articles generally appear credible?',
      ],
    },
    {
      header: 'Bias',
      body: [
        'Does the author or the organization have a bias? Does bias make sense in relation to your argument?',
        'Is the purpose of the content to inform, entertain, or to spread an agenda? Is there commercial intent?',
        'Are there ads?',
      ],
    },
    {
      header: 'Currency',
      body: [
        'When was the source published or updated? Is there a date shown?',
        'Does the publication date make sense in relation to the information presented to your argument?',
        'Does the source even have a date?',
      ],
    },
    {
      header: 'Reproduced',
      body: [
        'Was it reproduced? If so, from where?',
        'If it was reproduced, was it done so with permission? Copyright/disclaimer included?',
      ],
    },
  ],
}

export const extendedConsiderCredibility: Credibility = {
  header: credibilityHeader,
  body: [
    ...considerCredibility.body,
    {
      header: 'Citations',
      body: [
        'Is there a bibliography or are there citations/links to related credible sources?',
        'Conversely, are there credible sites or sources that refer/link to this content? In what context?',
      ],
    },
    {
      header: 'Relevance',
      body: [
        'Is the content relevant to your thesis statement?',
        'Is the tone (academic, casual, etc.) appropriate for your project?',
      ],
    },
    {
      header: 'Accuracy',
      body: [
        'Is the data verifiable and accurate?',
        'Are there spelling or grammatical errors? If online, are any of the links dead?',
      ],
    },
    {
      header: 'Complete',
      body: ['Is the source comprehensive?'],
    },
    {
      header: 'Credible',
      body: [
        'Based on previous criteria, decide whether the source is credible overall.',
      ],
    },
  ],
}

export default considerCredibility
